__turbopack_context__.v({
  "chartContainer": "Tokenomics-module__hEOWcq__chartContainer",
  "tokenAmount": "Tokenomics-module__hEOWcq__tokenAmount",
  "tokenCard": "Tokenomics-module__hEOWcq__tokenCard",
  "tokenCardTitle": "Tokenomics-module__hEOWcq__tokenCardTitle",
  "tokenGrid": "Tokenomics-module__hEOWcq__tokenGrid",
  "tokenPercentage": "Tokenomics-module__hEOWcq__tokenPercentage",
  "tokenomics": "Tokenomics-module__hEOWcq__tokenomics",
  "tokenomicsHeader": "Tokenomics-module__hEOWcq__tokenomicsHeader",
  "tokenomicsTitle": "Tokenomics-module__hEOWcq__tokenomicsTitle",
  "totalSupply": "Tokenomics-module__hEOWcq__totalSupply",
});
